var util = require('widgets-util');


var Transport;
module.exports = Transport = function Transport(options) {
    this.options = options;
    if(typeof this.options.baseUrl !== 'string') throw new Error('Option "baseUrl" missing');
}

Transport.supported = function() {
    return true;
};

Transport.prototype = {
  constructor: Transport,

  send: function(/*params, callback*/) {
    throw new Error('Each transport should implement .send');
  }
};

util.forEach(['GET', 'HEAD', 'OPTIONS', 'POST', 'PATCH', 'DELETE'], function(method) {
  Transport.prototype[method.toLowerCase()] = function(url) {
    return new ReqBuilder(this, method, url);
  };
});

var CONTENT_TYPE = 'Content-Type';

function ReqBuilder(transport, method, url) {
  this.transport = transport;
  this.params = { url: url, method: method };

  this._query = {};
  this._body = null;
  this._headers = {};

  this._bodyProcessors = {
    'application/x-www-form-urlencoded': util.formEncodedString,
    'application/json': JSON.stringify,
    'text/plain': function(body) { return String(body) }
  };
}

ReqBuilder.prototype = {
  form: function(name, value) {
    var body = {};
    body[name] = value;
    if(arguments.length === 1) {
      body = name;
    }
    this.body(body);
    this.header(CONTENT_TYPE, 'application/x-www-form-urlencoded');
    return this;
  },

  json: function(data) {
    this.body(data);
    this.header(CONTENT_TYPE, 'application/json');
    return this;
  },

  text: function(data) {
    this.body(data);
    this.header(CONTENT_TYPE, 'text/plain');
    return this;
  },

  body: function(data) {
    if(this._body) {
      util.deepExtend(this._body, data);
    } else {
      this._body = data;
    }
    return this;
  },

  query: function(name, value) {
    var query = {};
    query[name] = value;
    if(arguments.length === 1) {
      query = name;
    }
    util.deepExtend(this._query, query);
    return this;
  },

  header: function(name, value) {
    var headers = {};
    headers[name] = value;
    if(arguments.length === 1) {
      headers = name;
    }
    util.forEach(headers, function(v, n) {
      this._headers[n.toLowerCase()] = v;
    }, this);
    return this;
  },

  end: function(callback) {
    if(this._body) {
      var contentType = this._headers[CONTENT_TYPE.toLowerCase()];
      if(!contentType) throw new Error('Need to add content-type header');

      this.params.data = this._bodyProcessors[contentType](this._body);
    }

    var query = util.queryString(this._query);
    if(query !== '') {
      this.params.url += '?' + query;
    }

    this.params.headers = this._headers;
    return this.transport.send(this.params, callback);//in future we may want to return Promise
  }
}
